export const user = (state) => {
  return state.user;
};
export const WX_BASEURL = (state) => {
  return state.wx_baseUrl;
};
export const ZBZ_BASEURL = (state) => {
  return state.zbz_baseUrl;
};
export const JX_BASEURL = (state) => {
  return state.jx_baseUrl;
};
export const LDY_BASEURL = (state) => {
  return state.ldy_baseUrl;
};
export const TOP_BASEURL = (state) => {
  return state.top_baseUrl;
};
export const GJ_BASEURL = (state) => {
  return state.gj_baseUrl;
};



// WEBPACK FOOTER //
// ./src/store/getters.js